import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'
import { beforeRegistration } from './hooks/beforeRegistration';

const store = {
  namespaced: true,
  state: {
    key: null
  }
}

const KEY = 'google-analytics-extended'
export const GoogleAnalyticsExtended = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module: store }] },
  beforeRegistration,
  afterRegistration
})
